module.exports = __webpack_public_path__ + "img/selected6-min.19795e9b.png";